<template>
    <div id="ssq" class="w1200">
        <div class="title">
            <span>双色球-频道</span>
            <div>
                <!-- <a href="https://caipiao.ip138.com/shuangseqiu/"><span>双色球走势图/工具</span></a> -->
                <a target="_blank" href="https://www.cwl.gov.cn/ygkj/kjzb/"><span>双色球开奖直播</span></a>
                <a target="_blank" href="https://www.cwl.gov.cn/ygkj/kjgg/"><span>双色球开奖公告</span></a>
                <span @click="$router.push('/ssddt?type=ssq')">缩水单大厅</span>
                <span>十大缩水学霸排行</span>
                <a target="_blank" href="http://bbs.36886.net/forum.php?mod=forumdisplay&fid=8"><span>天云专区</span></a>
                <span @click="$router.push('/suoshuiruanjian'); $vuex('vuex_menuActiveIndex', 5)">双色球缩水软件</span>
            </div>
        </div>
        <div class="one">
            <div class="left">
                <!-- 指标排名 -->
                <ranking :rankingArr="rankingArr" lotteryType="0" />
            </div>
            <div class="right">
                <div class="left">
                    <!-- 指标学霸最新预测 -->
                    <forecast lotteryType="0" />
                </div>
                <div class="right">
                    <!-- 特征 -->
                    <tezheng lotteryType="0" />
                </div>
            </div>
        </div>

        <div class="two">
            <div class="left">
                <zhuanqu lotteryType="0" />
            </div>
            <div class="right">
                <ssqKaijiang />
            </div>
        </div>
    </div>
</template>

<script>
import ranking from "./components/ranking.vue";  /* 指标排名 */
import forecast from "./components/forecast.vue";   /**学霸最新预测 */
import ssqKaijiang from "./components/kaijiang/ssq.vue";
import zhuanqu from "./components/zhuanqu.vue";
import tezheng from "./components/tezheng.vue";		/**特征 */

export default {
    components: {
        ranking,
        forecast,
        ssqKaijiang,
        zhuanqu,
        tezheng,
    },
    data() {
        return {
            rankingArr: [
                '90-99.9万',
                "80-89.9万",
                "50-59.9万",
                "15-21.9万",
                "4-9.9万",
                "5005注↓",
                "杀6蓝",
                "围4蓝",
            ]
        };
    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/commonStyle.scss';

#ssq {
    margin-top: 20px;

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: $theme_color;
        // background-image: linear-gradient(to right,#8FB3DA,);
        padding: 0px 20px;
        padding-left: 0;

        >span {
            font-weight: bold;
            font-size: 28px;
            height: 60px;
            line-height: 60px;
            background-color: #fff;
            padding: 0 20px;
        }

        >div {
            color: #ffffff;
            font-weight: bold;

            >span,
            a {
                margin: 0 10px;
                display: inline-block;
                cursor: pointer;
                position: relative;
                transition: transform 0.5s linear, font-weight 0.5s linear;

                &:hover {
                    transform: scale(1.2);
                    font-weight: bold;

                    &::after {
                        width: 100%;
                        left: 0%;
                    }
                }

                &:not(:hover) {
                    transform: scale(1);
                    font-weight: inherit;

                    &::after {
                        width: 0%;
                        left: 50%;
                    }
                }

                &::after {
                    content: '';
                    display: block;
                    border-bottom: 3px solid #fff;
                    width: 0%;
                    position: absolute;
                    left: 50%;
                    bottom: -5px;
                    transition: width 0.5s linear, left 0.5s linear;
                }
            }
        }
    }

    .one {
        margin-top: 20px;
        display: flex;

        >div {
            &.left {
                flex: 1;
            }

            &.right {
                flex: 2;
                margin-left: 20px;
                display: flex;

                >div {
                    &.left {
                        flex: 2;
                    }

                    &.right {
                        flex: 1.3;
                        margin-left: 20px;
                    }
                }
            }
        }
    }

    .two {
        margin-top: 20px;
        display: flex;

        >div {

            // border: 1px solid red;
            &.left {
                flex: 1.5;
            }

            &.right {
                flex: 1;
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效，与 .w1200 容器自适应保持一致） ===== */
@media (max-width: 1200px) {
    // 频道标题改为竖排：标题文字一行，下面的链接另起一行并左对齐
    #ssq {
        .title {
            flex-direction: column;
            align-items: flex-start;

            // 链接行上下留点间距
            >div {
                padding: 10px 0;
            }
        }

        // 移动端：右侧区块去掉左边距与内部横向 flex，
        // 让 forecast / tezheng 竖向堆叠、完整可见，不超出屏幕
        // 注意：必须显式覆盖基础样式的 margin-left / display，仅注释掉不会生效
        .one {
            >div {
                &.right {
                    flex: 2;
                    margin-left: 0; // 覆盖基础样式的 margin-left: 20px
                    display: block; // 覆盖基础样式的 display: flex，子块改为竖向堆叠

                    // 内层子块：竖排后去掉分界线与左边距
                    >div {
                        &.left {
                            border-right: none; // 竖排后不再需要左右分界线
                        }

                        &.right {
                            margin-left: 0; // 覆盖基础样式的 margin-left: 20px
                        }
                    }
                }
            }
        }
    }
}
</style>